import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/tripadvisor': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M528.9 178.8c28.9 26.3 46.9 64.1 46.9 106.2 0 0.1 0 0.1 0 0.2h0c0 79.4-64.5 143.9-144 143.9-37.7 0-72.1-14.6-97.8-38.3l-46.1 50.2-46.1-50.2c-25.6 23.4-59.8 37.8-97.2 37.8-79.4 0-143.9-64.5-143.9-143.9 0-41.8 17.9-79.5 46.4-105.8l-47.1-51.2h104.7c52.2-35.5 115.9-56.3 183.8-56.3s130.9 20.8 183.2 56.3h104.3zM144.1 382.6c53.8 0 97.4-43.6 97.4-97.4s-43.6-97.4-97.4-97.4-97.4 43.6-97.4 97.4 43.6 97.4 97.4 97.4zM288 282.4c0-64.1 46.6-119.1 108.1-142.6-33.2-13.8-70.1-21.5-108.3-21.5-38.2 0-74.7 7.6-107.9 21.5 61.5 23.5 108.1 78.5 108.1 142.6zM431.9 382.6c53.8 0 97.4-43.6 97.4-97.4 0-53.8-43.6-97.4-97.4-97.4-53.8 0-97.4 43.6-97.4 97.4 0 53.8 43.6 97.4 97.4 97.4h0zM144.1 234.1c0 0 0 0 0.1 0 28.1 0 51 22.8 51 50.9v0.1c0 28.2-22.9 51.1-51.1 51.1s-51.1-22.9-51.1-51.1 22.9-51.1 51.1-51.1h0zM431.9 234.1c28.2 0 51.1 22.9 51.1 51.1s-22.9 51.1-51.1 51.1-51.1-22.9-51.1-51.1 22.9-51.1 51.1-51.1z'
      }
    ]
  }
})
